import React from "react";
import styles from "./style.module.scss";
import { Link } from "react-router-dom";

const HeaderSection = ({ title, link, link_name, id }) => {
  return (
    <section className={`${styles.headerSection} mt-5 pt-5`} id={id}>
      <div className={styles.title}>
        <h1>{title}</h1>
      </div>

      {link ? (
        <div className={styles.link_con}>
          <Link to={link} className={styles.link}>{link_name}</Link>
        </div>
      ) : (
        <div className={styles.arrow}>
          <img src="/assets/images/Arrow.svg" alt="arrow" />
        </div>
      )}
    </section>
  );
};

export default HeaderSection;
